<script lang="js" setup>
import ScrollLink from "@/components/ui/ScrollLink.vue";
import UiButton from "@/components/ui/UiButton.vue";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/vue";
import { isAuthenticated } from "@/services/token.js";
import { computed } from "vue";

const userIsAuthenticated = computed(() => isAuthenticated());
</script>

<template>
  <Disclosure
    as="nav"
    class="w-full sticky sm:static top-0 z-50 bg-primary-dark shadow-lg sm:shadow-none"
    v-slot="{ open }"
  >
    <div
      class="container max-w-screen-xl 2xl:max-w-screen-2xl mx-auto py-6 sm:py-8 flex items-center justify-between"
    >
      <router-link to="/">
        <img
          alt="Chat Polls Logo"
          class="h-8 sm:h-14"
          src="@/assets/chat-polls-logo.png"
        />
      </router-link>
      <div class="hidden sm:flex gap-x-14">
        <ScrollLink to="why-chat-polls">Why Chat-Polls</ScrollLink>
        <ScrollLink to="how-it-works">How it Works</ScrollLink>
        <ScrollLink to="testimonials">Testimonials</ScrollLink>
        <ScrollLink to="faq">FAQ</ScrollLink>
      </div>
      <router-link v-if="!userIsAuthenticated" to="/login">
        <UiButton class="hidden sm:inline-block">
          <span class="font-poppins text-lg font-semibold"> Sign In </span>
        </UiButton>
      </router-link>
      <router-link v-else to="/dashboard">
        <UiButton class="hidden sm:inline-block">
          <span class="font-poppins text-lg font-semibold"> Dashboard </span>
        </UiButton>
      </router-link>

      <!-- Mobile menu button -->
      <div class="sm:hidden">
        <DisclosureButton
          class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-1 focus:ring-primary"
        >
          <span class="absolute -inset-0.5" />
          <span class="sr-only">Open main menu</span>
          <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
          <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
        </DisclosureButton>
      </div>
    </div>

    <!-- Mobile menu panel -->
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <DisclosurePanel
        class="sm:hidden absolute top-20 inset-x-0 p-2 bg-primary-dark md:hidden"
      >
        <div class="space-y-1 pt-4 pb-3">
          <ScrollLink
            to="why-chat-polls"
            class="block px-3 py-2 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700"
          >
            Why Chat-Polls
          </ScrollLink>
          <ScrollLink
            to="how-it-works"
            class="block px-3 py-2 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700"
          >
            How it Works
          </ScrollLink>
          <ScrollLink
            to="testimonials"
            class="block px-3 py-2 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700"
          >
            Testimonials
          </ScrollLink>
          <ScrollLink
            to="faq"
            class="block px-3 py-2 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700"
          >
            FAQ
          </ScrollLink>
          <div class="px-3 py-2">
            <router-link v-if="!userIsAuthenticated" to="/login">
              <UiButton class="w-full">
                <span class="font-poppins text-lg font-semibold">
                  Sign In
                </span>
              </UiButton>
            </router-link>
            <router-link v-else to="/dashboard">
              <UiButton class="w-full">
                <span class="font-poppins text-lg font-semibold">
                  Dashboard
                </span>
              </UiButton>
            </router-link>
          </div>
        </div>
      </DisclosurePanel>
    </transition>
  </Disclosure>
</template>

<style scoped></style>
